module.exports = __webpack_public_path__ + "static/media/partner02.d8f2a498.svg";